import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../js/base';
import { isOutlineStylingActive, KeyCodes } from '../utils/index';

class Texts extends BaseObject {}

class ClassList extends BaseObject {}

class Selectors extends BaseObject {}

class Elements extends  BaseElements<Selectors> {

    constructor(selectors: Selectors) {
        super(selectors, true);
    }

}

interface A11y  extends BaseService<Selectors, Elements, ClassList, Texts>{ }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class A11y  {
    protected mousemoveHandlerBinded: (Event) => void;
    protected keydownHandlerBinded: (Event) => void;

    initialize() {
        if (!isOutlineStylingActive()) {
            return;
        }
        this.mousemoveHandlerBinded = this.mousemoveHandler.bind(this);
        this.keydownHandlerBinded = this.keydownHandler.bind(this);
        this.addEventListeners();
    }
    addEventListeners(): void {
        if (!this.mousemoveHandlerBinded) {
            return
        }
        document.body.addEventListener('mousemove', this.mousemoveHandlerBinded);
    }

    mousemoveHandler() {
        document.body.classList.add('mouse-user');
        document.body.removeEventListener('mousemove', this.mousemoveHandlerBinded);
        document.body.addEventListener('keydown', this.keydownHandlerBinded);
    }

    keydownHandler(event:KeyboardEvent) {
        if (!Object.values(KeyCodes).includes(event.keyCode)) {
            return;
        }
        document.body.classList.remove('mouse-user');
        document.body.removeEventListener('keydown', this.keydownHandlerBinded);
        document.body.addEventListener('mousemove', this.mousemoveHandlerBinded);
    }
}

export default A11y;

export {
    Elements as A11yElements,
    Selectors as A11ySelectors,
    ClassList as A11yClassList,
    Texts as A11yTexts
}